import { config } from "~/config"
import { useSystemLanguageStoreHook } from "~/store/modules/systemLaunage"
import useUserStore, { useUserStoreHook } from "~/store/modules/user"
import { NetCode, Token } from "~/types/const"
import { useCrossDomainCookie } from "@/composables/useCrossDomainCookie";
import Toast from "~/utils/toast";
const { getCrossDomainCookie } = useCrossDomainCookie();

export interface Response<T> {
    code: string
    message: string,
    data?: T
    [x: string]: any
}

interface DefaultOptions {
    method: 'get' | 'post' | 'put'
    params?: any
    body?: any
    data?: any
    headers?: Record<string, any>
    [x: string]: any
}

interface RequestOptions extends RequestInit {
    timeout?: number
    headers?: Record<string, any>
    uploadFlag?: boolean
    onProgress?: (progress: string) => void
}

class HttpRequest {
    static request<T>(url: string, method: 'get' | 'post' | 'put', params = {}, options?: RequestOptions): Promise<Response<T>> {
        // console.log("request uploadFlag", options?.uploadFlag, params)
        // 检测操作系统的函数
        function detectOS() {
            console.log('navigator.platform', navigator)
            const platform = navigator.platform;
            const userAgent = navigator.userAgent;
            if (/Win/i.test(platform) || /Win/i.test(userAgent)) {
                return 'web-windows';
            } else if (/Mac/i.test(platform) || /Mac/i.test(userAgent)) {
                return 'web-mac';
            } else {
                return 'web';
            }
        }
        let pathUrls = ['api/user/trade/save','api/user/basic/qqauth/code/login']
        let isUpload: boolean = options?.uploadFlag || false
        let isDevelopment = process.env.NODE_ENV === 'development'
         // 获取请求的路径是不是/api/user/trade/save，如果是才设置detectOS
         const path = url
         // 判断当前路径是否在目标列表中
        const isTargetPath = pathUrls.some(url => path?.includes(url))
        const platform = isTargetPath ? detectOS() : 'web'
        const lang = isDevelopment ? useCookie('lang') : getCrossDomainCookie('lang') || ''
        const deviceId = getCrossDomainCookie('deviceId').value || useCookie('deviceId').value || localStorage.getItem("deviceId") || ''
        const browserInfo = getBrowserInfo() || []
        let langCode = ""
        if (lang.value) {
            langCode = lang.value
            if (lang.value == 'zh') {
                langCode = "zh-CN"
            }else if (lang.value == 'hi') {
                langCode = "hib"
            }else if (lang.value == 'tw') {
                langCode = "zh-TW"
            }
        }
        console.log('langCode===',useCookie('lang'), langCode)

        const userStore = useUserStore()
        const requestToken = isDevelopment ? userStore.token || useCookie(Token).value || '' : userStore.token || getCrossDomainCookie(Token).value || ''
        let defaultOptions: DefaultOptions = {
            method,
            ...options,
            headers: {
                'internationalCode': langCode,
                "Accept": "application/json",
                clienttype: 'web',
                'appSource': platform,
                'deviceName': browserInfo.length > 0 ? browserInfo[0] : '',
                deviceid: deviceId,
                ...options?.headers
            },
        }
        // console.log('useUserStoreHook().userInfo', useUserStore(), useUserStoreHook())
        if (requestToken && userStore.isUserInfoReady && userStore.userInfo?.bizTeamId
            && !Object.prototype.hasOwnProperty.call(defaultOptions.headers, 'bizTeamId')) {
            defaultOptions.headers['bizTeamId'] = userStore.userInfo.bizTeamId
        }
        function getBrowserInfo()
        {
            var agent = navigator.userAgent.toLowerCase() ;
            var regStr_ie = /msie [\d.]+;/gi ;
            var regStr_ff = /firefox\/[\d.]+/gi
            var regStr_chrome = /chrome\/[\d.]+/gi ;
            var regStr_saf = /safari\/[\d.]+/gi ;
            //IE
            if(agent.indexOf("msie") > 0)
            {
                return agent.match(regStr_ie) ;
            }

            //firefox
            if(agent.indexOf("firefox") > 0)
            {
                return agent.match(regStr_ff) ;
            }

            //Chrome
            if(agent.indexOf("chrome") > 0)
            {
                return agent.match(regStr_chrome) ;
            }

            //Safari
            if(agent.indexOf("safari") > 0 && agent.indexOf("chrome") < 0)
            {
                return agent.match(regStr_saf) ;
            }

        }
        defaultOptions.headers = {
            ...defaultOptions.headers,
            token: requestToken
        }
        
        if (method === 'get') {
            defaultOptions.params = params
        } else if (method === 'post') {
            if (!isUpload) {
                defaultOptions.body = JSON.stringify(params)
            } else {
                defaultOptions.body = params.data
            }
        }
        url = url && url.startsWith('http') ? url : useRuntimeConfig().public.apiUrl + url

        console.log("defaultOptions ==== ", url)
        return new Promise((resolve, reject) => {
            if (isUpload == true) {
                $fetch(url, {...defaultOptions, onRequest: (request, optionss) => {
                    // console.log("request uploadFlag", request, optionss)
                    // 替换为支持进度的 Fetch 实现
                    const xhr = new XMLHttpRequest()
                    xhr.open(defaultOptions.method || 'GET', url)
                    
                    for (const [key, value] of Object.entries(defaultOptions.headers || {})) {
                        xhr.setRequestHeader(key, value)
                    }
                    
                    if (isUpload) {
                        xhr.upload.onprogress = (event) => {
                            if (event.lengthComputable) {
                                let progress = (event.loaded / event.total).toFixed(2)
                                if (options && options.onProgress) {
                                    options.onProgress(progress)
                                }
                            }
                        }
                        // console.log("request uploadFlag", event, isUpload)
                    }
                    
                    return new Promise((resolve, reject) => {
                        xhr.onload = () => resolve(new Response(xhr.response))
                        xhr.onerror = reject
                        xhr.send(defaultOptions.body)
                    })
                }}).then((res) => {
                    let response = res as Response<T>
                    if (config.requestLog) {
                        // console.log(`requestLog url: ${url} \n`, `params:`, params, '\n', 'response:', response,
                        //     "\n—————————————————————————————————————————————————————————————————"
                        // )
                    }
                    if (response.code === NetCode.TOKEN_EXPIRED) {
                        useUserStoreHook().tokenFail()
                        // const { $loginCom } = useNuxtApp();
                        // $loginCom.open();
                        resolve(response)
                    } else {
                        if (params && params.key) {
                            response.key = params.key
                        }
                        resolve(response)
                    }
                }).catch(err => {
                    if (config.requestLog) {
                        console.error('requestLog catch error', err)
                    }
                    reject(err)
                })
            } else {
                $fetch(url, defaultOptions).then((res) => {
                    let response = res as Response<T>
                    if (config.requestLog) {
                        // console.log(`requestLog url: ${url} \n`, `params:`, params, '\n', 'response:', response,
                        //     "\n—————————————————————————————————————————————————————————————————"
                        // )
                    }
                    if (response.code === NetCode.TOKEN_EXPIRED) {
                        useUserStoreHook().tokenFail()
                        // const { $loginCom } = useNuxtApp();
                        // $loginCom.open();
                        resolve(response)
                    } else if (response.code === NetCode.BIZ_DISABLE) {
                        if (response.message) {
                            Toast(response.message)
                        }
                        resolve(response)
                    } else if (response.code === NetCode.BIZ_MEMBER_DISABLE) {
                        if (response.message) {
                            Toast(response.message)
                        }
                        resolve(response)
                    }
                     else {
                        resolve(response)
                    }
                }).catch(err => {
                    if (config.requestLog) {
                        console.error('requestLog catch error', err)
                    }
                    reject(err)
                })
            }
        })
    }

    static get<T = any>(url: string, params: any | null, options?: RequestOptions): Promise<Response<T>> {
        return HttpRequest.request<T>(url, 'get', params, options)
    }

    static post<T = any>(url: string, params: any | null, options?: RequestOptions): Promise<Response<T>> {
        return HttpRequest.request<T>(url, 'post', params, options)
    }
}

export default HttpRequest;
